var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "white",
    stroke: "#B46C9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9389 23.9225H15.0669V20.3525H28.9389V23.9225Z",
    fill: "#B46C9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusPurpleIcon);
export default __webpack_public_path__ + "static/media/minusPurpleIcon.b46e17007865acf37dd616e2bdecb647.svg";
export { ForwardRef as ReactComponent };